import { Navigate, useLocation } from "react-router-dom";

const RequireAuth = ({children})=>{
    const token = localStorage.getItem("token");
    
    const location = useLocation();
    

    //如果没有token，重定向到login页面
    if(!token){
        // 默认navigate会增加历史记录，使用replace可以消除记录
        // state=...这里是给state传递了一个from属性，所以子组件可以通过location对象拿到from这个属性。
        return <Navigate to="/login" state={{from: location}} replace/>
    }

    return children;
}

export default RequireAuth;